<template>
    <render />
</template>

<script lang="ts" setup>
import { h } from 'vue'
import type {
    Color,
    ComponentFragment,
    ShopWithConfidenceProductFragment,
} from '@/graphql/api'

import CmsComponent from '@/components/cms/CmsComponent.vue'
import type { Props as RelatedProductProps } from '@/components/rings/RelatedProducts.vue'
import type { PageType } from '@/components/cms/component/content/ContentButton.vue'

const props = defineProps<{
    data: ComponentFragment[]
    background: Color
    hasEagerImage?: boolean
    relatedProducts?: RelatedProductProps
    product?: ShopWithConfidenceProductFragment
    pageType: PageType
}>()

const render = () =>
    props.data.map((component, index) => {
        return h(CmsComponent, {
            data: component,
            background: props.background,
            hasEagerImage: props.hasEagerImage && index === 0,
            relatedProducts: props.relatedProducts,
            product: props.product,
            pageType: props.pageType,
        })
    })
</script>
